import React from 'react'

import Spinner from '../Spinner'

import { LoadingContentWrapper, SpinnerWrapper } from './style'

const LoadingWrapper = ({ children, isLoading, height ='100%', width='100%', size, ...props }) => {
  return (
    <div data-testid='test-loading-wrapper' style={{ position: 'relative' }} {...props}>
      {isLoading && (
        <LoadingContentWrapper
          data-test={isLoading ? 'active-loading-wrapper' : 'loading-wrapper'}
          data-testid='test-loading-content-wrapper'
          active={isLoading ? 'flex' : 'none'}
          height={height}
          width={width}
        >
          <SpinnerWrapper>
            <Spinner size={size} />
          </SpinnerWrapper>
        </LoadingContentWrapper>
      )}
      {children}
    </div>
  )
}

export default LoadingWrapper
